import { Pharmacy } from './../../../interfaces/masters/pharmacy';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { StockListApi } from '../api/stockList.api';
import { switchMap, map } from 'rxjs/operators';
import { StockListData, StockLists ,AlertList,StockAdjustmentCreate, StockListCreate} from '../../../interfaces/pharmacy/StockLists';

@Injectable()
export class StockListService extends StockListData {

  constructor(private api: StockListApi) {
    super();
  }


  list(url: string): Observable<any[]> {
    return this.api.list(url);
  }
  salesPageOnLoadList(url: string,header:any): Observable<any[]> {
    return this.api.salesPageOnLoadList(url,header);
  }

  
alertMinList(url: string): Observable<AlertList[]> {
    return this.api.minList(url);
  }
  excessMaxList(url: string): Observable<AlertList[]> {
   
    return this.api.maxList(url);
  }
  getById(url:string): Observable<StockLists>{
      return this.api.getById(url);
  }

  create(url: string, data:StockLists): Observable<StockLists> {
    return this.api.add(url,data);
  }
  //
  stockcreate(url: string, data:StockListCreate): Observable<StockListCreate> {
    return this.api.stockadd(url,data);
  }
  stockAdjustmentcreate(url: string, data:StockAdjustmentCreate): Observable<StockAdjustmentCreate> {
    return this.api.stockAdjustmentadd(url,data);
  }
  //

  update(url: string, data:StockLists): Observable<StockLists> {
    return this.api.update(url,data);
  }
  
  searchList(url: string,data:any): Observable<any> {
    
    return this.api.searchList(url,data);
  }
  closingStockList(url: string): Observable<any[]> {
   
    return this.api.closingStockList(url);
  }
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
